import { calculateLostDaysText } from '@/config/templateConfigs';
import { useUserData } from '@/contexts/UserDataContext';
import { Slide2Template } from '@/templates/Slide2Template';
import { Button } from '../../components/Button';
import { TemplateOnScreenDisplay } from '../../components/TemplateOnScreenDisplay';

interface LostDaysPreviewStepProps {
    onNext: () => void;
}

export const LostDaysPreviewStep = ({ onNext }: LostDaysPreviewStepProps) => {
    const { userData } = useUserData();

    return (
        <>
            <div className='flex flex-col justify-center items-center w-full overflow-y-auto overflow-x-hidden px-8'>
                <TemplateOnScreenDisplay className="flex-shrink-0">
                    <Slide2Template text1={`${userData.totalLostDays} days`} text2={calculateLostDaysText(userData.totalLostDays)} />
                </TemplateOnScreenDisplay>

            </div>
            <div className="shrink-0 flex justify-center items-center w-full px-8">
                <Button label="Next" onClick={onNext} />
            </div>
        </>
    );
};
